<template>
  <v-menu v-if="!isEmbedded">
    <template #activator="{ props }">
      <v-avatar
        v-bind="props"
        size="45"
        color="primary"
        class="font-weight-medium pb-1 cursor-pointer"
        rounded="lg"
      >
        <template v-if="userInitials">
          {{ userInitials }}
        </template>
        <v-icon v-else size="28">mdi-account-circle</v-icon>
      </v-avatar>
    </template>
    <v-list class="pa-0">
      <v-list-item class="bg-primary pa-4" v-if="user">
        <v-list-item-title class="user-block__name font-weight-bold">
          {{ user?.firstName }} {{ user?.lastName }}
        </v-list-item-title>
        <v-list-item-subtitle class="user-block__email"
          >{{ user?.emailAddress }}
        </v-list-item-subtitle>
      </v-list-item>
      <v-list-item class="bg-primary pa-4" v-else>
        <v-list-item-title class="user-block__name font-weight-bold">
          Guest
        </v-list-item-title>
      </v-list-item>
      <v-list-item class="user-block__logout" @click="logoutModel = true" v-if="hasAccessToken">
        <template #prepend>
          <v-icon color="red-accent-4">mdi-logout</v-icon>
        </template>
        <v-list-item-title>Logout</v-list-item-title>
      </v-list-item>
      <v-list-item class="user-block__login" @click="login" v-else>
        <template #prepend>
          <v-icon color="primary">mdi-login</v-icon>
        </template>
        <v-list-item-title>Login</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
  <app-dialog
    v-if="!isEmbedded"
    v-model="logoutModel"
    title="Confirm"
    text="Are you sure you want to logout?"
    :width="400"
    @cancel="logoutModel = false"
    @confirm="logout"
  ></app-dialog>
</template>

<script lang="ts" setup>
import { ref, computed } from 'vue'
import { useRouter } from 'vue-router'

import AppDialog from './AppDialog.vue'

import { useAppStore } from '@/stores/app'
import AppService from '@/services/appService'
import { getAccessToken } from '@/api/idp'
import { isEmbedded } from '@/api/client'

const appStore = useAppStore()
const router = useRouter()

const user = computed(() => appStore.user)
const hasAccessToken = computed(() => Boolean(getAccessToken()))
const logoutModel = ref(false)

const userInitials = computed(() => {
  if (user.value) {
    return (user.value.firstName?.charAt(0) || '') + (user.value.lastName?.charAt(0) || '')
  }
  return null
})

const logout = async () => {
  logoutModel.value = false
  window.onbeforeunload = null
  const appService = new AppService()
  await appService.clearAuthData()
}

const login = () => {
  router.push({ name: 'Login' })
}
</script>

<style scoped lang="scss">
.cursor-pointer {
  cursor: pointer;
}
</style>
